import { ROUTES } from './routes.constants';

export const FOOTER_QUICK_LINKS = [
  { name: 'nav.home', href: ROUTES.HOME },
  { name: 'nav.sports', href: ROUTES.SPORTS },
  { name: 'nav.breaking', href: ROUTES.BREAKING },
  { name: 'nav.crypto', href: ROUTES.CRYPTO },
  { name: 'nav.politics', href: ROUTES.POLITICS },
  { name: 'nav.earnings', href: ROUTES.EARNINGS },
];

export const FOOTER_SUPPORT_LINKS = [
  { name: 'nav.helpCenter', href: '#' },
  { name: 'nav.contactUs', href: ROUTES.CONTACT_US },
  { name: 'nav.termsOfUse', href: ROUTES.TERMS },
  { name: 'nav.privacy', href: ROUTES.PRIVACY },
];
